export interface Facility {
  id: string;
  name: string;
  type: string;
  address: string;
  phone: string;
  email: string;
}
